import { PageHero, SectionHeading } from "@/components/Section";
import ReportingDashboard from "@/components/ReportingDashboard";
import { motion } from "framer-motion";
import { stagger, fadeUp } from "@/components/Reveal";
import { PortalButton } from "@/components/PortalButton";
import { Check } from "lucide-react";

const ACCESS = [
  "Current invoices", "Past invoices", "Credit notes", "Order history",
  "Downloadable PDF invoices", "Monthly purchase summaries", "Spending by product category",
  "Most frequently ordered products", "Highest-cost products", "Price & quantity history",
  "Delivery records", "Date-based reports", "Purchase comparisons", "Exportable reports",
];

export default function Reporting() {
  return (
    <>
      <PageHero
        chapter="Reporting & Invoices"
        title="All your orders, invoices & purchasing data in one place"
        lead="Stop searching through messages and paper invoices. Your complete purchasing history stays organized in one secure account."
      >
        <PortalButton variant="butter" testId="reporting-page-cta">See How the Platform Works</PortalButton>
      </PageHero>

      <section className="py-24 md:py-32 bg-cream">
        <div className="max-w-[1440px] mx-auto px-5 md:px-10">
          <SectionHeading chapter="Live Preview" overline="Purchasing Dashboard" title="A sample of your account reporting" className="mb-10" />
          <div className="rounded-3xl bg-sage/40 border border-forest/15 p-4 md:p-8">
            <ReportingDashboard />
          </div>
        </div>
      </section>

      <section className="py-24 md:py-32 bg-white border-t border-forest/10">
        <div className="max-w-[1440px] mx-auto px-5 md:px-10">
          <SectionHeading chapter="What You Can Access" overline="Everything In One Account" title="Your dashboard, from invoices to insights" className="mb-12" />
          <motion.div variants={stagger} initial="hidden" whileInView="show" viewport={{ once: true }} className="grid sm:grid-cols-2 lg:grid-cols-3 gap-x-8 gap-y-3">
            {ACCESS.map((a) => (
              <motion.div key={a} variants={fadeUp} className="flex items-center gap-3 border-b border-forest/10 py-3">
                <span className="grid place-items-center h-6 w-6 rounded-full bg-forest text-butter shrink-0"><Check className="h-3.5 w-3.5" /></span>
                <span className="text-sm font-medium text-forest">{a}</span>
              </motion.div>
            ))}
          </motion.div>
        </div>
      </section>
    </>
  );
}
